export const ACTIONABLE_BUTTON = 'actionable-button';
export const AUDIO_URL = 'audio-url';
export const DATA_LINK = 'data-link';
export const DATE = 'date';
export const HEIGHT = 'height';
export const HIDDEN = 'hidden';
export const IMAGE_URL = 'image-url';
export const SAFE_IMAGE_URL = 'safe-image-url';
export const PERCENT = 'percent';
export const PHONE_NUMBER = 'phone-number';
export const PREFORMATTED = 'pre';
export const TIMESTAMP = 'timestamp';
export const VIDEO = 'video';
export const VIDEO_URL = 'video-url';
export const WEB_PROXY = 'web-proxy';
export const WEB_URL = 'web-url';
export const WEIGHT = 'weight';
